/* eslint-disable quotes */
import React, { useState } from 'react'
import { CSVLink } from 'react-csv'
import { toast } from 'react-toastify'
import styled from '@emotion/styled'
import { Box, Button, Typography } from '@mui/material'
import PropTypes from 'prop-types'

import AdminAPI from '../../../api/orbitV1/AdminAPI'
import DownloadIcon from '../../../assets/icons/circles-design/download_icon.png'
import PlusIcon from '../../../assets/icons/circles-design/plus.png'
// Material UI Imports
import { ColorBoxContent } from '../../../common/ui/colorBox'

export default function OnboardSims({
  currentCustomer,
  goFirstPage,
  goPreviousPage,
  buttonDisabled,
  setButtonDisabled
}) {
  const [uploadedSims, setuploadedSims] = useState(null)

  const toastTime = 4000
  const handleSubmitSims = () => {
    if (!uploadedSims) {
      return toast.error('Please select a file to be uploaded.', {
        autoClose: toastTime
      })
    }

    const parseCsv = (str) => {
      const strArray = str.split('\n')
      const objList = []
      const firstArr = strArray[0].trim().split(',')

      // make headers to upper case
      objList.push({
        msisdn: firstArr[0].toUpperCase(),
        serviceInstanceId: firstArr[1].toUpperCase(),
        iccid: firstArr[2].toUpperCase(),
        plan: firstArr[3].toUpperCase()
      })

      // push rest of data as objs
      for (const eachStr of strArray.slice(1)) {
        const arr = eachStr.trim().split(',')
        objList.push({
          msisdn: arr[0],
          serviceInstanceId: arr[1],
          iccid: arr[2],
          plan: arr[3]
        })
      }
      return objList
    }

    // setError(false)
    const reader = new FileReader()

    reader.onload = async (e) => {
      const text = e.target.result

      const csvArray = parseCsv(text)
      const correctHeaders = {
        msisdn: 'MOBILE NUMBER',
        serviceInstanceId: 'SI NUMBER',
        iccid: 'ICCID',
        plan: 'PLAN NAME'
      }
      if (JSON.stringify(csvArray[0]) !== JSON.stringify(correctHeaders)) {
        toast.error('Incorrect column headers in your CSV file.', {
          autoClose: toastTime
        })
      } else {
        setButtonDisabled(true)

        toast.success(
          'Migration will take awhile, please check back again later'
        )
        setTimeout(() => {
          goPreviousPage()
        }, toastTime)

        // upload sims without headers
        const res = await AdminAPI.uploadSims({
          uploadSims: csvArray.slice(1),
          orgId: currentCustomer._id
        })

        if (res.status !== 200) {
          toast.error(
            'There was a problem migrating sim data, please try again'
          )
        } else {
          toast.success(
            `${csvArray.length - 1} SIMs successfully uploaded and migrated`,
            {
              autoClose: toastTime,
              hideProgressBar: false
            }
          )
        }

        setTimeout(() => {
          setButtonDisabled(false)
        }, toastTime)
      }
    }

    reader.readAsText(uploadedSims)
  }

  /* Figure styling */

  const FirstText = styled.div({
    position: 'relative',
    color: '#ccc',
    paddingRight: '0 1.5em',
    '&::after': {
      content: '""',
      position: 'absolute',
      zIndex: '2',
      right: -1,
      transform: 'translateX(50%)',
      borderRadius: '50%',
      background: '#EFC100',
      width: '16px',
      height: '16px'
    }
  })
  const Text = styled.div({
    padding: '0 1.5em 1.5em 1.5em',
    position: 'relative',
    '&::before': {
      content: '""',
      position: 'absolute',
      zIndex: '1',
      left: 0,
      height: '100%',
      borderLeft: '2px #B8C4D3 solid'
    }
  })
  const Strong = styled.div({
    display: 'block',
    fontWeight: 'bold',
    fontSize: 16
  })

  /* template in csv format */

  const headers = [
    { label: 'Mobile number', key: 'msisdn' },
    { label: 'SI number', key: 'serviceInstanceId' },
    { label: 'Iccid', key: 'iccid' },
    { label: 'Plan name', key: 'planname' }
  ]

  const mockCustomerData = [
    {
      'Mobile number': '87651234',
      'SI number': 'LW123456789',
      Iccid: '896503011810016550',
      'Plan name': 'CirclesOne'
    },
    {
      'Mobile number': '89123456',
      'SI number': 'LW987654321',
      Iccid: '896503011810016551',
      'Plan name': 'CirclesOne'
    }
  ]

  return (
    <Box>
      <Typography variant='h4'>Migrate Existing SIMs</Typography>
      <ColorBoxContent variant='white'>
        <Box display='flex' direction='column'>
          <Box
            sx={{
              display: 'inline-block'
            }}
          >
            <Box
              sx={{
                margin: '1em',
                width: '50%;'
              }}
            >
              <Box
                sx={{
                  display: 'flex'
                }}
              >
                <FirstText />
                <Text>
                  <Strong>
                    Download and follow this template to import existing
                    customers&apos; SIMs to Orbit
                  </Strong>
                  <Box
                    sx={{
                      marginBottom: '40px',
                      marginTop: '24px',
                      display: 'flex'
                    }}
                  >
                    <CSVLink
                      data={mockCustomerData}
                      header={headers}
                      filename='sim_migration_template.csv'
                      style={{ textDecoration: 'none' }}
                      // eslint-disable-next-line react/jsx-curly-brace-presence
                      enclosingCharacter={``}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center'
                        }}
                      >
                        <Typography
                          sx={{
                            color: '#0000FF',
                            fontSize: '18px',
                            fontWeight: 'bold'
                          }}
                        >
                          Download Template
                        </Typography>
                        <img
                          src={DownloadIcon}
                          alt='download-template-logo'
                          width='20px'
                          height='20px'
                        />
                      </Box>
                    </CSVLink>
                  </Box>
                </Text>
              </Box>
              <Box
                sx={{
                  display: 'flex'
                }}
                d
              >
                <FirstText />
                <Box sx={{ marginLeft: '1.5em' }}>
                  <Strong>
                    Ensure the Mobile Numbers, Service Instance (SI) Numbers,
                    ICCID Numbers and Plan Name are listed in the correct
                    columns.
                    <br />
                    Save and upload the file below.
                  </Strong>
                  <Typography>Upload File:</Typography>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      width: '80%',
                      border: '1px dashed #B8C4D3',
                      borderRadius: '8px'
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        margin: '50px 100px'
                      }}
                    >
                      <label
                        htmlFor='uploadNumbers'
                        style={{ cursor: 'pointer' }}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}
                        >
                          <img src={PlusIcon} alt='plus-icon' width='20px' />
                          <Typography
                            variant='h6'
                            sx={{
                              color: '#0000FF'
                            }}
                          >
                            Select File
                          </Typography>
                        </Box>
                      </label>
                      <input
                        id='uploadNumbers'
                        type='file'
                        accept='.csv'
                        onChange={(e) => setuploadedSims(e.target.files[0])}
                        hidden
                      />
                    </Box>
                  </Box>
                  {uploadedSims && (
                    <Box
                      sx={{
                        display: 'flex'
                      }}
                    >
                      <Typography>Uploaded File: </Typography>
                      <Typography variant='h6'>{uploadedSims.name}</Typography>
                    </Box>
                  )}
                  <Typography variant='subtitle1' sx={{ color: '#B8C4D3' }}>
                    .csv, max 8mb
                  </Typography>
                </Box>
              </Box>
            </Box>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end'
              }}
            >
              <Button variant='secondary' onClick={goFirstPage}>
                Back
              </Button>
              <Button
                variant='filled'
                onClick={handleSubmitSims}
                disabled={buttonDisabled}
              >
                Upload
              </Button>
            </Box>
          </Box>
        </Box>
      </ColorBoxContent>
    </Box>
  )
}
OnboardSims.propTypes = {
  currentCustomer: PropTypes.object,
  goFirstPage: PropTypes.func,
  goPreviousPage: PropTypes.func,
  buttonDisabled: PropTypes.bool,
  setButtonDisabled: PropTypes.func
}
